import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="https://titc.io/wp-content/uploads/2025/02/Logo-FA.png" 
                alt="SA FinTech Awards"
                className="h-10"
              />
            </div>
            <p className="text-gray-400">
              Celebrating excellence and innovation in South Africa's financial technology sector.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-gray-400 hover:text-white transition-colors">
                  Categories
                </Link>
              </li>
              <li>
                <Link to="/judging-process" className="text-gray-400 hover:text-white transition-colors">
                  Judging Process
                </Link>
              </li>
              <li>
                <Link to="/winners" className="text-gray-400 hover:text-white transition-colors">
                  Winners
                </Link>
              </li>
              <li>
                <Link to="/event" className="text-gray-400 hover:text-white transition-colors">
                  The Event
                </Link>
              </li>
              <li>
                <Link to="/sponsors" className="text-gray-400 hover:text-white transition-colors">
                  Sponsors
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-indigo-400" />
                <a href="mailto:info@titc.io" className="text-gray-400 hover:text-white">
                  info@titc.io
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-indigo-400" />
                <a href="tel:+27210125989" className="text-gray-400 hover:text-white">
                  +27 21 012 5989
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <MapPin className="h-4 w-4 text-indigo-400" />
                <span className="text-gray-400">Cape Town, South Africa</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Linkedin className="h-6 w-6" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Twitter className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} South African FinTech Awards. All rights reserved.{' '}
            <Link to="/privacy-policy" className="hover:text-white transition-colors">
              Privacy Policy & Terms
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;